import { parseISO } from 'date-fns';
import { getESTDateString } from '../hooks/useGameReset';

const START_DATE_STRING = '2025-07-26';

export function getDayNumber(): number {
  const today = getESTDateString();
  const todayDate = parseISO(today);
  const startDate = parseISO(START_DATE_STRING);

  const diffMs = todayDate.getTime() - startDate.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return diffDays + 1;
}
